@if (!exibirFichaDaObra) {
<div class="card obras-por-fase-card p-4">
  <h5 class="card-title">Obras por fase de Mercado</h5>

  <div class="filtros d-flex mb-4">
    <app-filtro-responsavel
      [responsavel]="responsavel"
      [(filtroResponsavel)]="selectedUsuario"
      (responsavelIdChange)="onResponsavelIdChange($event)"
      (responsavelLimpo)="onResponsavelIdChange(0)"
      (responsaveisChange)="onResponsaveisRecebidos($event)"
    ></app-filtro-responsavel>

    <app-filtro-periodo
      [intervaloSelecionado]="selectedPeriodo"
      [config]="config"
      (intervaloSelecionadoChange)="onPeriodoSelecionadoChange($event)"
    ></app-filtro-periodo>

    <div class="custom-dropdown">
      <div class="input-filtro-selecionado">
        <button
          type="button"
          class="dropdown-toggle"
          (click)="toggleFaseObra()"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/filter.svg"
            width="20"
            height="20"
          />
          {{
            filtroFaseObraSelecionados.length === 0
              ? "Todas as fases"
              : filtroFaseObraSelecionados.length + " fase(s) selecionada(s)"
          }}
        </button>
        <button
          *ngIf="filtroFaseObraSelecionados.length"
          type="button"
          class="btn-clear"
          (click)="limparFasesObra()"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarFaseObra" class="dropdown-list">
        <label>
          <input
            type="radio"
            name="fase"
            [value]="'Todas'"
            [checked]="filtroFaseObraSelecionados.length === 0"
            (change)="onFaseChange($event)"
          />
          Todas
        </label>
        <label *ngFor="let fase of todasAsFases">
          <input
            type="radio"
            name="fase"
            [value]="fase.marketPhaseID"
            [checked]="filtroFaseObraSelecionados.includes(fase.marketPhaseID)"
            (change)="onFaseChange($event)"
          />
          {{ fase.marketPhase }}
        </label>
      </div>
    </div>

    <app-filtro-tipo-obra
      (tiposSelecionadosChange)="onTiposSelecionadosChange($event)"
    ></app-filtro-tipo-obra>

    <button type="button" class="btn btn-dark" (click)="exportExcel()" [disabled]="desabilitarExportar">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/agenda-tarefas/download.svg"
        width="20"
        height="20"
        alt=""
      />
      EXPORTAR
    </button>
  </div>

  <div class="view-switch mb-4 d-flex justify-content-between">
    <div class="d-flex">
      <button
        type="button"
        class="btn btn-visao-geral"
        [ngClass]="{
          'btn-dark': viewMode === 'chart',
          'btn-outline-secondary': viewMode !== 'chart'
        }"
        (click)="toggleView('chart')"
      >
        <img
          src="{{
            BASE_IMG_URL
          }}assets/agenda-tarefas/grafico-de-pizza.png"
          width="16"
          height="16"
          alt=""
        />
        Visão Geral
      </button>
      <button
        type="button"
        class="btn"
        [ngClass]="{
          'btn-dark': viewMode === 'table',
          'btn-outline-secondary': viewMode !== 'table'
        }"
        (click)="toggleView('table')"
      >
        <img
          src="{{ BASE_IMG_URL }}assets/agenda-tarefas/table.svg"
          width="16"
          height="16"
          alt=""
        />
        Visão por Obras
      </button>
    </div>
  </div>

  <div
    class="grafico-apex row align-items-center justify-content-center"
    *ngIf="viewMode === 'chart' && fasesDaObra.length > 0"
  >
    <div class="grafico-legenda-flex">
      <div class="grafico-pizza">
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [labels]="chartOptions.labels"
          [colors]="chartOptions.colors"
          [plotOptions]="chartOptions.plotOptions"
          [tooltip]="chartOptions.tooltip"
          [legend]="chartOptions.legend"
          [responsive]="chartOptions.responsive"
        ></apx-chart>
      </div>
      <div
        class="custom-legend-table"
        *ngIf="chartOptions.series?.length && chartOptions.labels?.length"
      >
        <table>
          <thead>
            <tr>
              <th>Legenda</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let label of chartOptions.labels; let i = index">
              <td>
                <span
                  class="color-dot"
                  [ngStyle]="{ background: chartOptions.colors[i] }"
                ></span>
                {{ label }}
              </td>
              <td>{{ chartOptions.series[i] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div
    *ngIf="fasesDaObra.length === 0 && tableData.length === 0"
    class="no-results"
  >
    Não há resultados para os filtros selecionados.
  </div>

  <div
    class="table-container table-responsive"
    *ngIf="viewMode === 'table' && tableData.length > 0"
  >
    <app-tabela-paginacao
      [columns]="columns"
      [data]="tableData"
      (workNameClick)="onWorkNameSelected($event)"
      (companyNameClick)="onCompanyNameClick($event)"
      [trackByFn]="trackByFn"
      [pagination]="{
        page: currentPage,
        pageFirst: 1,
        pageLast: totalPages,
        pageNext: currentPage < totalPages ? currentPage + 1 : null,
        pagePrev: currentPage > 1 ? currentPage - 1 : null,
        recordsCount: tableData.length,
        pageActive: true,
        pageSize: 10,
        shortcuts: 0,
        hasValue: tableData.length > 0,
        shortcutPages: [],
        records: tableData
      }"
      (paginaMudada)="mudarPagina($event)"
    ></app-tabela-paginacao>
  </div>
</div>
}
